/**
 * Retrieve member details
 * @param {string} idToken 
 * @returns 
 */
export const externalLogin = async (idToken) => {
  const result = await fetch(process.env.REACT_APP_HIP_URL + process.env.REACT_APP_OSAPI_API_PREFIX + '/api/accounts/login', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_A
    },
    body: JSON.stringify({
      clientId: process.env.REACT_APP_APP_ID,
      idToken,
      isEntraLogin: true
    })
  })
  return result.json();
}